import { Fragment, useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { SpinLoading, Empty } from "antd-mobile";
import useNavigation from "../../hooks/useNavigation";
import PageWrap from "../components/PageWrap";
import PageHeader, { headerHeight } from "../components/PageHeader";
import { useStores } from "../../models";
import { ToastError } from "../../components/Toast";
import { formatPrice } from "../../utils";

const ScrollArea = styled.div`
  height: calc(100% - ${headerHeight});
  overflow: auto;
  background: #f7f8ff;
`;

const PeddingOrderLog = () => {
  const { params } = useNavigation();
  const stores = useStores();
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState<any[]>([]);

  const load = async () => {
    try {
      setLoading(true);
      const id = params.id || window.location.pathname.split("/").pop();
      const detail = await stores.orderStore.loadMyOrderDetail(id);
      setList(detail?.data?.order_list || detail?.data?.tack_orders || detail?.order_list || []);
    } catch (e: any) {
      ToastError(e.message || "加载失败");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id]);

  return (
    <PageWrap>
      <PageHeader title="成交记录" />
      <ScrollArea>
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center", padding: 40 }}><SpinLoading /></div>
        ) : list.length === 0 ? (
          <Empty description="暂无数据" style={{ padding: 40 }} />
        ) : (
          list.map((item, idx) => (
            <Fragment key={item.order_no || item.id || idx}>
              <div style={{ background: "#fff", margin: "8px 12px", padding: 12, borderRadius: 8 }}>
                <div>{item.username || item.name || item.order_no}</div>
                <div>{formatPrice(item.amount || 0)} / 状态 {item.status}</div>
              </div>
            </Fragment>
          ))
        )}
      </ScrollArea>
    </PageWrap>
  );
};

export default observer(PeddingOrderLog);
